import styled, { keyframes } from "styled-components";
import { colours } from "../../../../../styles/colours.constants";
import { satoshi700 } from "../../../../../styles/font.constants";
import { spacing } from "../../../../../styles/styles.constants";

const pulse = keyframes`
	from {
		opacity: 0.2;
	}
	to {
		opacity: 1;
	}
`;

export const VarReview = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	background: ${colours.red};
	${satoshi700}
	font-size: 1rem;
	color: ${colours.white};
	margin-bottom: 1rem;
	padding: ${spacing.padding};
	cursor: default;

	span {
		animation: ${pulse} 1.2s ease-in-out infinite alternate;
	}
`;
